import React, { useEffect, useState } from "react"
import * as Yup from "yup"
import { useFormik } from "formik"
import withRouter from "components/Common/withRouter"
import PropTypes from "prop-types"
import {
  Card,
  CardBody,
  Form,
  Row,
  Col,
  Label,
  Input,
  FormFeedback,
} from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { createSelector } from "reselect"
import Spinners from "components/Common/Spinner"
import {
  getSACHSNCodeDetail,
  addNewSACHSNCode,
  updateSACHSNCode,
} from "store/masters/sac&hsncode/actions"

const NewSACHSNCode = props => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const codeState = state => state.sachsn.codeDetail.data
  const loadingState = state => state.sachsn.loading
  const [isEditMode, setIsEditMode] = useState(false)
  const codeProperties = createSelector(
    codeState,
    loadingState,
    (code, loading) => {
      return {
        code: code,
        loading: loading,
      }
    }
  )
  const { code, loading } = useSelector(codeProperties)
  const [codeId, setCodeId] = useState()
  const [isLoading, setLoading] = useState(loading)

  const vendorData = () => {
    try {
      const url = new URL(window.location.href)
      if (url.href.includes("edit")) {
        setIsEditMode(true)
      }

      const codeId = url.pathname.split("/edit-sac-hsn-code-master/")[1]
      setCodeId(codeId)

      dispatch(getSACHSNCodeDetail(codeId))
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    if (location.pathname.includes("edit")) {
      vendorData()
    }
  }, [dispatch])

  useEffect(() => {
    if (location.pathname.includes("edit")) {
      setIsEditMode(true)
    }
  }, [location.pathname])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: isEditMode
      ? {
          sac_hsm_code: (code && code.sac_hsm_code) || "",
          description: (code && code.description) || "",
          is_active: Boolean(code && code.is_active),
        }
      : {
          sac_hsm_code: "",
          description: "",
          is_active: false,
        },
    validationSchema: Yup.object({
      sac_hsm_code: Yup.string().required("Please Enter Your SAC / HSM Code"),
      description: Yup.string(),
      is_active: Yup.boolean(),
    }),

    onSubmit: async values => {
      if (isEditMode === true) {
        dispatch(updateSACHSNCode(codeId, values, props.router.navigate))
      } else if (isEditMode === false) {
        dispatch(addNewSACHSNCode(values, props.router.navigate))
      }
    },
  })

  return (
    <div className="page-content">
      {isLoading ? (
        <Spinners setLoading={setLoading} />
      ) : (
        <>
          <Row>
            <Col>
              <div className="d-flex gap-2 mb-3">
                <i
                  className="mdi mdi-arrow-left font-size-20"
                  style={{ color: "grey", marginRight: "15px" }}
                  onClick={() => {
                    navigate(-1)
                  }}
                ></i>

                <span
                  style={{
                    color: "black",
                    fontWeight: "500",
                    fontSize: "18px",
                  }}
                >
                  {" "}
                  {isEditMode
                    ? "Edit SAC / HSN Code Master"
                    : "New SAC / HSN Code Master"}{" "}
                </span>
              </div>
            </Col>
            <Col>
              <Breadcrumbs title="Settings / Master configuration / SAC OR HSN Code Master" />
            </Col>
          </Row>
          <div className="mt-3"></div>
          <Card>
            <CardBody>
              <Form
                autoComplete="off"
                onSubmit={e => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}
              >
                <Row>
                  <Col>
                    <div className="mb-3">
                      <Label htmlFor="formrow-sac_hsm_code-Input">
                        SAC / HSN Code*
                      </Label>
                      <Input
                        type="text"
                        name="sac_hsm_code"
                        className="form-control"
                        id="formrow-sac_hsm_code-Input"
                        placeholder="Enter SAC / HSN Code"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.sac_hsm_code || ""}
                        invalid={
                          validation.touched.sac_hsm_code &&
                          validation.errors.sac_hsm_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.sac_hsm_code &&
                      validation.errors.sac_hsm_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.sac_hsm_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col>
                    <div className="mb-3">
                      <Label htmlFor="formrow-description-Input">
                        Description*
                      </Label>
                      <Input
                        type="text"
                        name="description"
                        className="form-control"
                        id="formrow-description-Input"
                        placeholder="Enter Description"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.description || ""}
                        invalid={
                          validation.touched.description &&
                          validation.errors.description
                            ? true
                            : false
                        }
                      />
                      {validation.touched.description &&
                      validation.errors.description ? (
                        <FormFeedback type="invalid">
                          {validation.errors.description}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="mb-2"></div>
                    <div>
                      <Label htmlFor="formrow-ispaid-Input">Is Active</Label>
                    </div>

                    <Col lg="12">
                      <div className="form-check form-check-inline">
                        <Input
                          type="checkbox"
                          className="form-check-Input"
                          id="is_active"
                          name="is_active"
                          onChange={e => {
                            validation.setFieldValue(
                              "is_active",
                              e.target.checked
                            )
                          }}
                          checked={Boolean(validation?.values?.is_active)}
                        />
                        <Label className="form-check-Label" htmlFor="is-Active">
                          <h6>Yes</h6>
                        </Label>
                      </div>
                      {validation.touched.is_active &&
                        validation.errors.is_active && (
                          <FormFeedback type="invalid">
                            {validation.errors.is_active}
                          </FormFeedback>
                        )}
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="mb-3 text-end">
                      <button type="submit" className="btn btn-primary w-md">
                        {isEditMode ? "Edit" : "Submit"}
                      </button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
        </>
      )}
    </div>
  )
}

export default withRouter(NewSACHSNCode)

NewSACHSNCode.propTypes = {
  history: PropTypes.object,
}
